

export class GenericValidators {
    constructor() {}
  
    public static isText(str):Boolean {
      str = new String(str);
      
      let pattern = /^\D{2,40}\s\D{2,40}$/gm;
      return str.match(pattern);
    }

    public static isPlaca(str):Boolean {
      str = new String(str);
      let pattern = /^[a-zA-Z0-9]{7}$/gm;
      return str.match(pattern);
    }

    public static isChassi(str):Boolean {
      str = new String(str);
      let pattern = /^[a-zA-Z0-9]{7,17}$/gm;
      return str.match(pattern);
    }

    public static isNumber(str):Boolean {
      str = new String(str);
      let pattern = /\d+/g;
      return str.match(pattern);
    }

    public static isEmail(str):Boolean {
      str = new String(str);
      let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g;
      return str.match(pattern);
    }

    public static isPhoneNumber(strIn):Boolean {
      strIn = new String(strIn);
      let str = strIn.replace(/[\(\)\-\s\.]+/g,'');      
      if(str.length == 10 || str.length == 11){
        let pattern = /\d+/g;
        return str.match(pattern);
      }else{
        return false;
      }
    }
    
    public static isValidCnpj(cnpj):Boolean {
      cnpj = new String(cnpj);
      
        cnpj = cnpj.replace(/[^\d]+/g,'');
 
        if(cnpj == '') return false;
        
        if (cnpj.length != 14)
            return false;
    
        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" || 
            cnpj == "11111111111111" || 
            cnpj == "22222222222222" || 
            cnpj == "33333333333333" || 
            cnpj == "44444444444444" || 
            cnpj == "55555555555555" || 
            cnpj == "66666666666666" || 
            cnpj == "77777777777777" || 
            cnpj == "88888888888888" || 
            cnpj == "99999999999999")
            return false;
            
        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0,tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;
            
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
              return false;
              
        return true;
      }
    

    public static isValidCpf(cpf):Boolean {
      if(cpf === '99999999999'){
        return true;
      }
      
      cpf = new String(cpf);
        if (cpf) {
          cpf = cpf.replace(/[^\d]+/g,'');
          let numbers, digits, sum, i, result, equalDigits;
          equalDigits = 1;
          if (cpf.length != 11) {
           return false;
          }
  
          for (i = 0; i < cpf.length - 1; i++) {
            if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
              equalDigits = 0;
              break;
            }
          }
  
          if (!equalDigits) {
            numbers = cpf.substring(0, 9);
            digits = cpf.substring(9);
            sum = 0;
            for (i = 10; i > 1; i--) {
              sum += numbers.charAt(10 - i) * i;
            }
  
            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  
            if (result !== Number(digits.charAt(0))) {
              return false;
            }
            numbers = cpf.substring(0, 10);
            sum = 0;
  
            for (i = 11; i > 1; i--) {
              sum += numbers.charAt(11 - i) * i;
            }
            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  
            if (result !== Number(digits.charAt(1))) {
              return false;
            }
            return true;
          } else {
            return false;
          }
       }
      return false;
  }
}
  